(() => {
 const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
 const cleanups = new Map();
 function setupRows(root = document) {
  root.querySelectorAll('[data-product-row]').forEach(row => {
   if (cleanups.has(row) || row.dataset.autoplay !== 'true') return;
   const viewport = row.querySelector('.row-window'), track = row.querySelector('.row-track'), toggle = row.querySelector('[data-motion-toggle]');
   if (!track.children.length || track.querySelector('.empty-state')) return;
   let paused = reduceMotion.matches, hovered = false, focused = false, touchedUntil = 0, raf, last = 0, cycle = 0, position = 0;
   const originals = [...track.children];
   function measure() {
    track.querySelectorAll('[data-clone]').forEach(n => n.remove());
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    cycle = originals.reduce((sum, n) => sum + n.getBoundingClientRect().width + gap, 0);
    if (!cycle) return;
    const copies = Math.ceil(viewport.clientWidth / cycle) + 1;
    for (let i = 0; i < copies; i++) originals.forEach(n => {
     const c = n.cloneNode(true); c.dataset.clone = 'true'; c.setAttribute('aria-hidden','true');
     if (c.matches('a,button')) c.tabIndex = -1;
     c.querySelectorAll('a,button,input,select').forEach(el => el.tabIndex = -1);
     track.append(c);
    });
    position = row.dataset.direction === 'right' ? cycle : 0; viewport.scrollLeft = position;
   }
   measure();
   toggle.hidden = false;
   const label = () => {toggle.textContent = paused ? 'play motion' : 'pause motion'; toggle.setAttribute('aria-pressed',String(paused));}; label();
   toggle.addEventListener('click',() => { paused = !paused; label(); });
   row.addEventListener('mouseenter',() => hovered = true); row.addEventListener('mouseleave',() => hovered = false);
   row.addEventListener('focusin',() => focused = true); row.addEventListener('focusout',e => focused = row.contains(e.relatedTarget));
   ['pointerdown','wheel','touchstart'].forEach(event => viewport.addEventListener(event,() => touchedUntil = performance.now() + 4000,{passive:true}));
   const changeMotion = () => {paused = reduceMotion.matches; label();}; reduceMotion.addEventListener('change',changeMotion);
   const resize = new ResizeObserver(measure); resize.observe(viewport);
   function frame(now) {
    const dt = Math.min(now - (last || now),50); last = now;
    if (!paused && !hovered && !focused && now > touchedUntil && !document.hidden && cycle) {
     const direction = row.dataset.direction === 'right' ? -1 : 1;
     position += direction * Number(row.dataset.speed) * dt / 1000;
     if (position >= cycle) position -= cycle;
     if (position < 0) position += cycle;
     viewport.scrollLeft = position;
    }
    raf = requestAnimationFrame(frame);
   }
   raf = requestAnimationFrame(frame);
   cleanups.set(row,() => {cancelAnimationFrame(raf);resize.disconnect();reduceMotion.removeEventListener('change',changeMotion);});
  });
 }
 setupRows();
 document.addEventListener('shopify:section:load',e => setupRows(e.target));
 document.addEventListener('shopify:section:unload',e => {e.target.querySelectorAll('[data-product-row]').forEach(row => {cleanups.get(row)?.();cleanups.delete(row);});});
 document.addEventListener('change',e => {
  if (!e.target.matches('[data-variant-select]')) return;
  const select = e.target, option = select.selectedOptions[0], product = select.closest('[data-product]');
  product.querySelector('[data-price]').textContent = option.dataset.price;
  const button = product.querySelector('[data-add-button]'); button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'sold out' : 'add to cart';
  const url = new URL(location.href); url.searchParams.set('variant',option.value); history.replaceState({},'',url);
  if (option.dataset.media) document.getElementById('Media-'+option.dataset.media)?.scrollIntoView({block:'nearest',inline:'start',behavior:reduceMotion.matches?'instant':'smooth'});
 });
 document.addEventListener('keydown',e => {if (e.key === 'Escape') document.querySelectorAll('.nav-dropdown[open]').forEach(d => {d.open = false;d.querySelector('summary').focus();});});
 document.addEventListener('click',e => document.querySelectorAll('.nav-dropdown[open]').forEach(d => {if (!d.contains(e.target)) d.open = false;}));
})();
